import { isUltimate } from '@merchant-backend/util'
import { notUltimateAlert, statistic } from '..'

const createDecorator = func => config => (target, name, descriptor) => {
  const original = descriptor.value
  descriptor.value = function(...args) {
    if (func(config) === false) return
    return original.apply(this, args)
  }
  return descriptor
}

export const pro = createDecorator(({ content, shouldBreak = true }) => {
  if (!isUltimate()) {
    notUltimateAlert(content)

    if (shouldBreak) return false
  }
})

export const STAT = createDecorator(key => statistic(key))
